/*
 * Copyright (c) Nexign, JSC, 2025.
 */
/**
 * New campaign rateplan card
 *
 * @author Nikolay Sviridov
 * @version 1.39.0
 * @since 1.39.0
 */

import { useSelector } from 'react-redux';

import { makeSelectTranslationPageProducts } from '@modules/internationalization/intSelectors';
import { ProductCardInternetLimited } from '@pages/PageProducts/components/ProductCards/ProductCardInternetLimited';
import { IProductCardTariffField } from '@pages/PageProducts/tariffsAndServicesProductTariffTypes';

import { RatePlanCard2025Head } from './RatePlanCard2025Head';
import { PriceSection } from './RatePlanCard2025Sections/PriceSection';
import { RoamingsSection } from './RatePlanCard2025Sections/RoamingsSection';
import {
	DescriptionSections,
	RatePlanCard2025BodyStyled,
	RatePlanCard2025Styled,
} from './styled/RatePlanCard2025Styled';
import type {
	IRoamingsProps,
	IMegaPowersProps,
	IPriceSectionProps,
} from './types/RatePlanCard2025Types';

interface IRatePlanCard2025Props
	extends IRoamingsProps,
		IMegaPowersProps,
		IPriceSectionProps {
	categoryName?: string;
	rateplanName: string;
	backgroundColor?: string;
	rateplanIcon?: string;
    internetLimited?: IProductCardTariffField<string[]>,
    limitConnections?: number;
    connected?: number;
}

export const RatePlanCard2025 = (props: IRatePlanCard2025Props) => {
	const {
		backgroundColor,
		categoryName,
		rateplanName,
		rateplanIcon,
		roamings,
		internetLimited,
		totalPrice,
        limitConnections,
        connected,
	} = props;

    const { campaignTariffsCard: cardTranslation } = useSelector(makeSelectTranslationPageProducts());

	return (
		<RatePlanCard2025Styled>
			<RatePlanCard2025Head
				backgroundColor={backgroundColor}
				categoryName={categoryName}
				connected={connected}
				limitConnections={limitConnections}
                rateplanIcon={rateplanIcon}
                rateplanName={rateplanName}
			/>
			<RatePlanCard2025BodyStyled>
				<DescriptionSections>
                    {roamings && <RoamingsSection {...roamings} />}
                    <ProductCardInternetLimited
                        cardTranslation={cardTranslation}
                        internetLimited={internetLimited}
                    />
                    {!!totalPrice &&
                        <PriceSection
                            totalPrice={totalPrice}
                        />
                    }
				</DescriptionSections>
			</RatePlanCard2025BodyStyled>
		</RatePlanCard2025Styled>
	);
};
